import React, {useState} from 'react';
import {Popover, Button, DataTable} from "@shopify/polaris";

import {OrderItem} from "../services/ConsignmentService";

type OrderItemsPopoverProps = {
    orderItems: OrderItem[]
}

const OrderItemsPopover = ({orderItems} : OrderItemsPopoverProps) => {
    const [popoverActive, setPopoverActive] = useState(false);

    const onOpenPopover = () => {
        setPopoverActive(!popoverActive);

    }

    return (
        <Popover
            active={popoverActive}
            sectioned
            activator={(
                <Button
                    fullWidth
                    disclosure
                    textAlign="left"
                    onClick={onOpenPopover}
                >
                    {orderItems.length.toString()} Items
                </Button>
            )}
            autofocusTarget="first-node"
            onClose={() => setPopoverActive(false)}
        >
            <DataTable
                columnContentTypes={[
                    "text",
                    "numeric"
                ]}
                headings={[
                    "Product",
                    "Quantity"
                ]}
                rows={orderItems.map(item => {
                    return [item.productDescription, item.orderedQuantity];
                })}
            />
        </Popover>
    )
};

export default OrderItemsPopover;